import React from "react";
import { MenuItem, TextField } from "@mui/material";
import { RECEIPT_STATE_ERROR, RECEIPT_STATE_INIT, RECEIPT_STATE_PAID } from "../../utils/listitem";
import { useTranslation } from "react-i18next";


const ReceiptStateSelect = (props) => {
    const { t } = useTranslation();
    return <TextField {...props} label={t('RECEIPT_STATE')} select>
        <MenuItem value={""}>{t("ALL")}</MenuItem>
        <MenuItem value={RECEIPT_STATE_INIT}>{t(RECEIPT_STATE_INIT)}</MenuItem>
        <MenuItem value={RECEIPT_STATE_PAID}>{t(RECEIPT_STATE_PAID)}</MenuItem>
        <MenuItem value={RECEIPT_STATE_ERROR}>{t(RECEIPT_STATE_ERROR)}</MenuItem>
    </TextField>;
}

export default ReceiptStateSelect;
